<template>
    <section>
        <v-textarea
        label="Escribe tus pasatiempos"
        v-model="pasatiempos"
        ></v-textarea>
        <v-btn
          block
          dark
          color="indigo darken-4"
          elevation="2"
          @click="emitir"
        >
            Aceptar
        </v-btn>
    </section>
</template>
<script>
    export default{
        name: "PasaTiempos",

        data: ()=>({
            pasatiempos: "",
        }),

        methods: {
            emitir(){
                this.$emit("pasatiempos", this.pasatiempos)
            }
        }
    }
</script>